/**
 * The adversaries screen's route path, kept beside the `routes.ts` that registers it, same
 * convention as `../monitoring/paths.ts`. Chosen here: neither the spec nor Figma names a URL
 * for this screen (no Figma frame exists for it either -- see `./routes.ts`'s module doc).
 */

export const ADVERSARIES_PATH = '/c/$campaignId/adversaries';
